import { Component, ElementRef, input, viewChild } from '@angular/core';

@Component({
  selector: 'rid-word-path-gap',
  imports: [],
  templateUrl: './rid-word-path-gap.html',
})
export class RidWordPathGap {
  isWide = input<boolean>(false);

  rootEl = viewChild.required<ElementRef<HTMLElement>>('rootEl');

  public getSnapPosition() {
    const el = this.rootEl().nativeElement;
    const rect = el.getBoundingClientRect();

    return { x: rect.left + rect.width / 2, y: rect.top };
  }
}
